<template>
  <div class="home_wrap">
    <Header></Header>
    <van-row class="topSection">
      <van-col span="24" style="text-align: left">
        <span style="color: #ffffff; font-size: 30px; font-weight: 700">{{
          $t("team.topic")
        }}</span>
      </van-col>
    </van-row>
    <van-row style="padding: 10px">
      <van-row class="TeamBox">
        <!-- --------- Direct Downline ------ -->
        <van-row style="padding-top: 25px">
          <van-col span="10">
            <p class="detailList">{{ $t("team.directDownline") }}</p>
          </van-col>
          <van-col span="14" style="text-align: right">
            <div class="linktext">
              <router-link to="/teamdirectdownline">
                <span class="detailInfo">{{ agentData.direct_downline }}</span>
                <van-icon name="arrow" class="linkIcon" />
              </router-link>
            </div>
          </van-col>
        </van-row>
        <!-- --------- Total Investment ------ -->
        <van-row style="padding-top: 25px">
          <van-col span="10">
            <p class="detailList">{{ $t("team.totalInvestment") }}</p>
          </van-col>
          <van-col span="14">
            <div class="linktext">
              <span class="detailInfo">$ {{ agentData.totalinvest }}</span>
              <!-- <van-icon name="arrow" class="linkIcon" /> -->
            </div>
          </van-col>
        </van-row>

        <!-- --------- Total Downline ------ -->
        <van-row style="padding-top: 25px">
          <van-col span="10">
            <p class="detailList">{{ $t("team.totalDownline") }}</p>
          </van-col>
          <van-col span="14">
            <div class="linktext">
              <span class="detailInfo">{{ agentData.total_downline }}</span>
              <!-- <van-icon name="arrow" class="linkIcon" /> -->
            </div>
          </van-col>
        </van-row>

        <!-- --------- Link Register ------ -->
        <van-row style="padding-top: 25px">
          <van-col span="10">
            <p class="detailList">{{ $t("team.linkRegister") }}</p>
          </van-col>
          <van-col span="14">
            <p class="linktext">
              <span class="detailInfo" @click="copyLink">
                {{ $t("team.invitationLink") }} |
                <span style="color: #eada3e">{{ $t("team.copy") }}</span>
              </span>

              <!-- <van-icon name="arrow" class="linkIcon" /> -->
            </p>
          </van-col>
        </van-row>

        <!-- --------- Direct Investment Amount ------ -->
        <van-row style="padding-top: 25px">
          <van-col span="10">
            <p class="detailList">{{ $t("team.directInvestment") }}</p>
          </van-col>
          <van-col span="14">
            <div class="linktext">
              <span class="detailInfo"
                >$ {{ agentData.direct_downline_investment }}</span
              >
              <!-- <van-icon name="arrow" class="linkIcon" /> -->
            </div>
          </van-col>
        </van-row>

        <!-- --------- Direct Downline Commission ------ -->
        <van-row style="padding-top: 25px">
          <van-col span="10">
            <p class="detailList">{{ $t("team.downlineCommission") }}</p>
          </van-col>
          <van-col span="14">
            <div class="linktext">
              <span class="detailInfo"
                >${{ agentData.direct_downline_commission }}</span
              >
              <!-- <van-icon name="arrow" class="linkIcon" /> -->
            </div>
          </van-col>
        </van-row>

        <!-- --------- Own Profit ------ -->
        <van-row style="padding-top: 25px">
          <van-col span="10">
            <p class="detailList">{{ $t("team.ownProfit") }}</p>
          </van-col>
          <van-col span="14">
            <div class="linktext">
              <router-link to="/teamprofit">
                <span class="detailInfo">${{ agentData.profit }}</span>
                <van-icon name="arrow" class="linkIcon" />
              </router-link>
            </div>
          </van-col>
        </van-row>
        <!-- --------- Total Benefit ------ -->
        <van-row style="padding-top: 25px">
          <van-col span="10">
            <p class="detailList">{{ $t("team.totalBenefit") }}</p>
          </van-col>
          <van-col span="14">
            <div class="linktext">
              <span class="detailInfo"
                >${{
                  (
                    parseFloat(agentData.direct_downline_commission) +
                    parseFloat(agentData.profit)
                  ).toFixed(2)
                }}</span
              >
              <!-- <van-icon name="arrow" class="linkIcon" /> -->
            </div>
          </van-col>
        </van-row>
        <!-- --------- Salary ------ -->
        <van-row style="padding-top: 25px">
          <van-col span="10">
            <p class="detailList">{{ $t("team.Salary") }}</p>
          </van-col>
          <van-col span="14">
            <div class="linktext">
              <span class="detailInfo">${{ agentData.bonus }}</span>
              <!-- <van-icon name="arrow" class="linkIcon" /> -->
            </div>
          </van-col>
        </van-row>
      </van-row>
    </van-row>
    <Footer></Footer>
  </div>
</template>

<script>
import Vue from "vue";
import Header from "../../components/header";
import Footer from "../../components/footer";
import { Icon, Col, Row } from "vant";
import Fetch from "../../utils/fetch";
import { Clipboard } from "@capacitor/clipboard";
import { async } from "q";

Vue.use(Icon).use(Row).use(Col);

export default {
  name: "team",
  components: {
    Header,
    Footer,
  },
  data() {
    return {
      agentData: {},
    };
  },
  mounted() {
    this.getData();
  },
  methods: {
    getData() {
      Fetch("/agent_account/index").then((res) => {
        if (res.code == 1) {
          this.agentData = res.data;
        }
      });
    },
    copyLink() {
      let that = this;
      Clipboard.write({
        string: that.agentData.link,
      });
      this.$toast.success();
    },
  },
};
</script>

<style lang="less" scoped>
.home_wrap {
  width: 100%;
  min-height: 100vh;
  background: url("../images/common/BgImg.png");
  background-size: 100% 100%;
  padding-bottom: 60px;
}

.topSection {
  align-items: center;
  display: flex;
  justify-content: center;
  padding: 25px 15px 0px;
}

.imageback {
  height: 40px;
  width: auto;
}

.TeamBox {
  box-shadow: rgb(0 0 0 / 24%) 0px 3px 8px;
  border: 1px solid #ffffff;
  border-radius: 13px;
  padding: 15px;
  background: #ebebeb29;
  margin-top: 25px;
}

.detailList {
  font-size: 17px;
  color: #ebedf0;
  word-break: break-word;
}

.detailInfo {
  font-size: 17px;
  color: #ffffff;
  padding-left: 10px;
  word-break: break-word;
}

.linktext {
  display: block;
  text-align: right;
  align-items: center;
}

.linkIcon {
  color: #ebedf0;
  font-size: 18px;
}
</style>
